// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"22e4a1c3","625":"1dc8f4c9","662":"d7896105","774":"42599ebb","787":"97cacf44","936":"856a2677","978":"ff5379ef"}[chunkId] + ".chunk.js";
};